/**
 * FIXTURES — seed initial pour Super Admin « Charger Douala / Yaoundé / Bafoussam ».
 * Source de vérité runtime : collection Firestore `pickupCities`.
 */
export type PickupZoneCity = {
  id: string;
  label: string;
  districts: string[];
};

/** @fixture Données de développement pour le sélecteur ville/quartier. */
export const PICKUP_ZONE_CITIES_FIXTURE: PickupZoneCity[] = [
  {
    id: 'douala',
    label: 'Douala',
    districts: [
      'Akwa',
      'Bonanjo',
      'Bonapriso',
      'Bonamoussadi',
      'Deido',
      'Makepe',
      'New Bell',
      'Logpom',
      'PK 14',
      'Bepanda',
    ],
  },
  {
    id: 'yaounde',
    label: 'Yaoundé',
    districts: [
      'Bastos',
      'Mvog-Ada',
      'Nlongkak',
      'Essos',
      'Melen',
      'Odza',
      'Ngousso',
      'Emana',
      'Etoudi',
      'Mokolo',
    ],
  },
  {
    id: 'bafoussam',
    label: 'Bafoussam',
    districts: ['Centre urbain', 'Banengo', 'Tamdja', 'Famla'],
  },
];

export function findPickupZoneCity(cityLabel: string): PickupZoneCity | undefined {
  const needle = cityLabel.trim().toLowerCase();
  return PICKUP_ZONE_CITIES_FIXTURE.find((c) => c.label.toLowerCase() === needle);
}
